import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
// import 'bootstrap/dist/css/bootstrap.css'
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import { Badge, TextField, Box, Button, Paper } from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import AddForm from "../../helpers/AddForm";
import StatusLayout from "components/Status";

const ProductManagement = ({
  location,
  SetSelectedMenu,
  resources,
  GetAllResources,
}) => {
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [count, setCount] = React.useState(0);
  const [selected, setSelected] = React.useState(
    location.state?.status ?? "all"
  );
  const [deleteOpen, setDeleteOpen] = React.useState(false);

  // Date filter states
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateFilterApplied, setDateFilterApplied] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setSelected(location.state?.status ?? "all");
  }, [location.state]);

  useEffect(() => {
    SetSelectedMenu({
      menu: "product",
      title: "Product Management",
    });
    GetAllResources();
  }, []);

  // Handle date filter changes
  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);

    if (fromDate && e.target.value) {
      setDateFilterApplied(true);
      setCount((v) => v + 1); // Trigger data reload
    }
  };

  // Clear date filters
  const clearDateFilter = () => {
    setFromDate("");
    setToDate("");
    setDateFilterApplied(false);
    setCount((v) => v + 1); // Trigger data reload
  };

  const columns = [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "launchedOn",
      label: "Launched On",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
      },
    },
    {
      name: "client",
      label: "Client",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "owner.names",
      label: "Product Owner",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "type",
      label: "Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status} />
            </span>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <BasicMenu
            onDetails={() => {
              const obj = list.find((vx) => vx.id === v);
              history.push(`/admin/product/${obj.type}/table/${obj.id}`);
            }}
            onDelete={() => {
              setDeleteOpen(true);
              setId(v);
            }}
            onEdit={() => {
              setOpen(2);
              const obj = list.find((vx) => vx.id === v);
              setId(v);
              setValue0("name", obj.name);
              setValue0(
                "launchedOn",
                moment(obj.launchedOn).format("YYYY-MM-DD")
              );
              setValue0("client", obj.client);
              setValue0("productOwnerId", obj.productOwnerId);
              setValue0("type", obj.type);
              setValue0("status", obj.status);
            }}
          />
        ),
      },
    },
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const onSuccess = () => setCount((v) => v + 1);

  const buildUrlWithFilters = () => {
    let url = `/api/product/list?status=${selected}&count=${count}`;
    if (dateFilterApplied && fromDate && toDate) {
      url += `&fromDate=${fromDate}&toDate=${toDate}`;
    }
    return url;
  };

  const processData = (data) => {
    let filteredData = data.data;

    if (dateFilterApplied && fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      to.setHours(23, 59, 59);

      filteredData = data.data.filter((item) => {
        const launchDate = new Date(item.launchedOn);
        return launchDate >= from && launchDate <= to;
      });

      // Update the full data object
      data = {
        ...data,
        data: filteredData,
      };
    }

    setList(filteredData);
    return data;
  };

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/product/delete/${id}`}
      />
      <AddForm
        col={6}
        open={open > 0}
        onSuccess={onSuccess}
        setOpen={setOpen}
        url={open === 1 ? "/api/product/create" : `/api/product/update/${id}`}
        method="POST"
        title={open === 1 ? "Create New Product" : "Edit Product"}
        mainFields={[
          {
            title: "",
            fields: [
              {
                name: "name",
                label: "Product name",
                value: value["name"],
                required: true,
                setValue: (val) => {
                  setValue0("name", val);
                },
              },
              {
                name: "launchedOn",
                label: "Launched On",
                type: "date",
                value: value["launchedOn"],
                required: true,
                setValue: (val) => setValue0("launchedOn", val),
              },
              {
                name: "client",
                label: "Client",
                type: "select",
                value: value["client"],
                required: true,
                values: [
                  {
                    label: "Govt",
                    id: "govt",
                  },
                  {
                    label: "Private",
                    id: "private",
                  },
                  {
                    label: "Both",
                    id: "both",
                  },
                ],
                setValue: (val) => setValue0("client", val),
              },
              {
                name: "productOwnerId",
                label: "Product Owner",
                value: value["productOwnerId"],
                values: resources?.data?.map((v) => ({
                  label: v.names,
                  id: v.id,
                })),
                required: false,
                type: "select",
                setValue: (val) => setValue0("productOwnerId", val),
              },
              {
                name: "status",
                label: "Status",
                type: "select",
                value: value["status"],
                required: true,
                values: [
                  {
                    label: "Active",
                    id: "active",
                  },
                  {
                    label: "Inactive",
                    id: "inactive",
                  },
                ],
                setValue: (val) => setValue0("status", val),
              },
              {
                name: "type",
                label: "Type",
                type: "select",
                value: value["type"],
                required: true,
                values: [
                  {
                    label: "EMS",
                    id: "EMS",
                  },
                  {
                    label: "VMS",
                    id: "VMS",
                  },
                ],
                setValue: (val) => setValue0("type", val),
              },
            ],
          },
        ]}
      />

      <DatatableComponent
        order={location.state?.order}
        onRowClick={(data, { rowIndex }) => {
          history.push(
            `/admin/product/${list[rowIndex].type}/table/${list[rowIndex].id}`
          );
        }}
        onAddNew={() => setOpen(1)}
        processData={processData}
        elevation={1}
        columns={columns}
        url={buildUrlWithFilters()}
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <span>
              Product Management{" "}
              {location.state?.status
                ? `(Status: ${location.state?.status})`
                : ""}
            </span>

            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <div className="md:w-full w-1/6 mb-2 xl:mb-0">
                <Paper
                  component="form"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "80%",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <label
                    style={{
                      minWidth: "80px",
                      maxWidth: "80px",
                      textAlign: "center",
                    }}
                    className="min-w-24 text-[#9295AB] text-ml px-3 py-1 font-light placeholder-blueGray-300 text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    FROM
                  </label>

                  <input
                    className="px-3 py-1 placeholder-blueGray-300 border-5 text-blueGray-600 bg-gray rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    max={toDate}
                  />
                </Paper>
              </div>

              <div className="md:w-full w-1/6 mb-2 xl:mb-0">
                <Paper
                  component="form"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "80%",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <label
                    style={{
                      minWidth: "80px",
                      maxWidth: "80px",
                      textAlign: "center",
                    }}
                    className="min-w-24 text-[#9295AB] text-ml px-3 py-1 font-light placeholder-blueGray-300 text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  >
                    TO
                  </label>

                  <input
                    className="px-3 py-1 placeholder-blueGray-300 border-5 text-blueGray-600 bg-gray rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    min={fromDate}
                  />
                </Paper>
              </div>

              {dateFilterApplied && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={clearDateFilter}
                >
                  Clear
                </Button>
              )}
            </Box>
          </Box>
        }
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductManagement);
